module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "info.2c5cb62a.svg";